import { useTranslation } from "react-i18next";
import ImageWithFallback from "@components/ui/ImageFallback";
import {
  Carbs,
  Kcal,
  NitroTech,
} from "@utils/defaultImages";
import InfoGridCard from "@components/ui/InfoGridCard";

const DietOverviewContent = ({
  tab,
  selectedMeal,
  selectedDay,
  variant,
  handleOpenRecipe
}) => {
  const { t } = useTranslation();

  const nutrientData = [
    {
      label: "Protein",
      key: "Protein",
      icon: <NitroTech className="min-w-[30px] min-h-[30px]" />,
      unit: "g",
      tabColor: "rgb(215 223 255)",
      value:
        tab.category === "meals"
          ? selectedMeal?.nutrition?.[tab.type]?.Protein
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Proteins,
    },
    {
      label: "Calorie",
      key: "calories",
      icon: <Kcal className="min-w-[30px] min-h-[30px]" />,
      unit: "kCal",
      tabColor: "rgb(245 224 210)",
      value:
        tab.category === "meals"
          ? selectedMeal?.calories?.[tab.type]
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Calories,
    },
    {
      label: "Carbs",
      key: "Carbohydrates",
      icon: <Carbs className="min-w-[30px] min-h-[30px]" />,
      unit: "g",
      tabColor: "rgb(208 241 255)",
      value:
        tab.category === "meals"
          ? selectedMeal?.nutrition?.[tab.type]?.Carbohydrates
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Carbohydrates,
    },
  ];

  if (tab.category === "meals") {
    return (
      <>
        <div className="w-[100%] relative">
          <ImageWithFallback
            src={`${selectedMeal.image?.[tab.type]}`}
            alt={tab.type}
            className="w-[100%] max-h-[300px] xl:max-h-[282px] min-h-[250px] rounded-lg !object-cover"
          />
          <div
            className="absolute inset-0 rounded-[10px] z-[1]"
            style={{
              background:
                "linear-gradient(180deg, rgba(102, 102, 102, 0) 0%, #000000 100%)",
            }}
          />
          <div className="absolute top-[15px] right-[15px] flex justify-center z-[2]">
            <button
              onClick={handleOpenRecipe}
              className="px-[20px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-[100px] text-[12px] sm:text-[14px] min-w-[120px] border border-white"
            >
              {t("dietPlanDashboard.mealListing.viewDetails")}
            </button>
          </div>
          <div className="absolute bottom-0 left-[15px] flex items-center justify-between mb-3 gap-2 z-[2]">
            <h3 className="text-[22px] font-[Lato] font-[600] text-[white] max-w-[90%]">
              {selectedMeal.meal_name?.[tab.type]}
            </h3>
          </div>
        </div>

        <h3 className="text-[14px] font-[Lato] font-[600] mb-2 mt-[12px]">
          {t("dietPlanDashboard.mealListing.mealNutrient")}
        </h3>
        
        <InfoGridCard
          data={nutrientData}
          columns={3}
          gap="gap-4"
          rounded="rounded-[20px]"
          t={t}
        />
      </>
    );
  }

  return (
    <>
      <div className="relative bg-white flex flex-col-reverse gap-[10px] rounded-[10px] mb-[10px]">
        <div className="flex justify-center">
          <ImageWithFallback
            src={`${
              selectedMeal.image?.[
                tab.type === "afternoon"
                  ? "afternoon_snacks"
                  : "evening_snacks"
              ]
            }`}
            alt={tab.type}
            className="w-[100%] max-h-[300px] xl:max-h-[285px] min-h-[300px] rounded-lg !object-cover"
          />
          <div
            className="absolute inset-0 rounded-[10px] z-[1]"
            style={{
              background:
                "linear-gradient(180deg, rgba(102, 102, 102, 0) 0%, #000000 100%)",
            }}
          />

          <div className="absolute bottom-[15px] left-[15px] flex justify-center z-[2]">
            <div
              className="flex flex-col justify-center gap-1 sm:gap-2 rounded-[20px] py-2 px-4"
              style={{
                background:
                  "linear-gradient(112.83deg, rgba(255, 255, 255, 0.47) 0%, rgba(255, 255, 255, 0) 110.84%)",
              }}
            >
              {selectedMeal.snacks?.[
                `${tab.type}_snacks`
              ]?.SnackItems?.slice(0, 2)?.map((item, index) => (
                <div
                  key={index}
                  className="text-[#0575e6] cursor-default text-[12px] md:text-[16px] font-[Lato] font-[500] rounded-full px-2 sm:px-2 py-1 flex items-center gap-1 sm:gap-2 w-[fit-content] max-w-[200px] sm:max-w-[250px] xl:max-w-[350px]"
                >
                  <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center flex-shrink-0 text-[#696969]">
                    {index + 1}
                  </p>
                  <span
                    title={item.trim()}
                    className="text-white whitespace-nowrap overflow-hidden text-ellipsis max-w-[100%]"
                  >
                    {item.trim()}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="absolute bottom-0 left-[15px] flex items-center justify-between mb-3 gap-2 z-[2]">
            <h3 className="text-[22px] font-[Lato] font-[600] text-[white]">
              {selectedMeal.meal_name?.[tab.type]}
            </h3>
          </div>
        </div>
      </div>

      <InfoGridCard
        data={nutrientData}
        columns={3}
        gap="gap-4"
        rounded="rounded-[20px]"
        t={t}
      />
    </>
  );
};

export default DietOverviewContent;